import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = {
  key: 0,
  id: "el-drawer__title",
  class: "el-drawer__header"
}
const _hoisted_3 = ["title"]
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "el-drawer__close el-icon el-icon-close" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "el-drawer__body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_overlay = _resolveComponent("el-overlay")!
  const _directive_trap_focus = _resolveDirective("trap-focus")!

  return (_openBlock(), _createBlock(_Teleport, {
    to: "body",
    disabled: !_ctx.appendToBody
  }, [
    _createVNode(_Transition, {
      name: "el-drawer-fade",
      onAfterEnter: _ctx.afterEnter,
      onAfterLeave: _ctx.afterLeave,
      onBeforeLeave: _ctx.beforeLeave
    }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_el_overlay, {
          mask: _ctx.modal,
          "overlay-class": _ctx.modalClass,
          "z-index": _ctx.zIndex,
          class: "el-drawer__open",
          onClick: _ctx.onModalClick
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", {
              ref: "drawerRef",
              "aria-modal": "true",
              "aria-labelledby": "el-drawer__title",
              "aria-label": _ctx.title,
              class: _normalizeClass(['el-drawer', _ctx.direction, _ctx.customClass]),
              style: _normalizeStyle(_ctx.isHorizontal ? 'width: ' + _ctx.drawerSize : 'height: ' + _ctx.drawerSize),
              role: "dialog",
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
            }, [
              (_ctx.withHeader)
                ? (_openBlock(), _createElementBlock("header", _hoisted_2, [
                    _renderSlot(_ctx.$slots, "title", {}, () => [
                      _createElementVNode("span", {
                        role: "heading",
                        title: _ctx.title
                      }, _toDisplayString(_ctx.title), 9, _hoisted_3)
                    ]),
                    (_ctx.showClose)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          "aria-label": 'close ' + (_ctx.title || 'drawer'),
                          class: "el-drawer__close-btn",
                          type: "button",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)))
                        }, _hoisted_6, 8, _hoisted_4))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.rendered)
                ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
                    _renderSlot(_ctx.$slots, "default")
                  ]))
                : _createCommentVNode("", true)
            ], 14, _hoisted_1)), [
              [_directive_trap_focus]
            ])
          ]),
          _: 3
        }, 8, ["mask", "overlay-class", "z-index", "onClick"]), [
          [_vShow, _ctx.visible]
        ])
      ]),
      _: 3
    }, 8, ["onAfterEnter", "onAfterLeave", "onBeforeLeave"])
  ], 8, ["disabled"]))
}